<template>
  <div
    class="main-page"
    v-scroll="handleOnScroll"
    :class="isLeftSideMin ? '--min-side-nav' : '--max-side-nav'"
    :v-bind="resetProps"
  >
    <NavBar>
      <template #nav-page-title="props">
        <slot name="nav-page-title" v-bind="{ ...props }" />
      </template>
      <template #nav-links>
        <slot name="nav-links" />
      </template>
    </NavBar>
    <v-main class="app-main">
      <AsideNavBar />
      <div class="wrapper" :class="[...pageClasses]" id="main_wrapper">
        <slot name="default" />
      </div>
    </v-main>
  </div>
</template>

<script>
import { EventConstraints } from "@/enums/events.enum";
import { StorageConstants } from "@/enums/storage.enum";
import Storage from "@/services/storage";
import Vue from "vue";
import { $eventHub } from "@/components";
import { mapMutations } from "vuex";
import { AppsConstraints } from "@/enums/apps.enum";
export default Vue.extend({
  name: "AppWrapper",

  props: {
    pageClasses: {
      type: [Array, String],
      default: null,
    },
  },

  data() {
    return {
      isLeftSideMin: false,
    };
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },

  beforeMount() {
    Storage.set(StorageConstants.LEFT_SIDE, Storage.get(StorageConstants.LEFT_SIDE) || false);
    this.initCallCenterEvents();
    this.handleSideNavInit();
  },

  beforeDestroy() {
    this.destroyCallCenterEvents();
  },

  mounted() {
    $eventHub.$on(EventConstraints.TOGGLE_LEFT_SIDE_NAV, this.handleSideNavInit);
  },

  destroyed() {
    $eventHub.$off(EventConstraints.TOGGLE_LEFT_SIDE_NAV, this.handleSideNavInit);
  },

  methods: {
    ...mapMutations({
      intiBack4App: "Business/SET_BRANCHES_STATUES",
      destroyBack4App: "Business/DESTROY_BRANCHES_STATUES",
    }),

    /**
     * Init Call Center Events
     * @return {void}
     */
    async initCallCenterEvents() {
      if (this.$route.meta?.app !== AppsConstraints.CALL_CENTER) {
        return;
      }
      await this.intiBack4App();
    },

    /**
     * Init Call Center Events
     * @return {void}
     */
    async destroyCallCenterEvents() {
      if (this.$route.meta?.app === AppsConstraints.CALL_CENTER) {
        return;
      }
      await this.destroyBack4App();
    },

    /**
     * Handle left side nav init
     * @return {void}
     */
    handleSideNavInit() {
      this.isLeftSideMin = Storage.get(StorageConstants.LEFT_SIDE) || false;
    },

    /**
     * Handle on windwo scroll
     * @return {void}
     */
    handleOnScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.isAsideFullHeight = top > 20;
    },
  },
});
</script>
